import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainContainer from '../../components/containers/MainContainer';
import actionsFactory from '../../store/actions/factory/dbItemsActionFactory';
// import { debounce } from 'lodash';
import { t } from 'i18next';
import { toast } from 'sonner';
import { useMutation, useQueryClient } from 'react-query';
import { SearchContext } from '../../features/project/building/Building';
import NLeftPanel from '../../components/NLeftPanel';
import { UPDATE_CONTRACT } from '../../store/actions/actionTypes';
import { apiService } from '../api';

const withLeftPanelWrapper = (Component, name, withVersion = false, disableAdd = false) => {
  const splittedName = name.split(/(?=[A-Z])/);
  let path = splittedName.join('-').toLowerCase();
  if (name === 'propertySet') {
    path = 'set-property-definition';
  }
  if (name === 'technicalReportItemSet') {
    path = 'set-technical-report-item';
  }
  if (name === 'contractListing') {
    path = 'contract';
  }
  if (name === 'typeMarkTemplate') {
    path = 'instance-type-template';
  }
  // eslint-disable-next-line react/display-name
  return () => {
    const permission = useSelector((state: any) => state.auth.pagePermission);

    const { contract, modelId } = useSelector((state: any) => state.contract);
    const contractId = contract?.id ?? null;
    const { detail } = useSelector((state: any) => state[name]);

    const [openDialog, setOpenDialog] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [search, setSearch] = useState(null);
    const [filter, setFilter] = useState({ is_active: [true] });
    const queryClient = useQueryClient();
    const queryKey = path;

    const dispatch = useDispatch();
    const { fetchDetail, clear } = actionsFactory(name, withVersion);

    const create = useMutation({
      mutationFn: (values: any) => {
        return apiService.post(`/api/v1/${queryKey}/`, {
          ...(values as any),
          contract: contractId,
          model: name === 'phase' ? (values as any).model : modelId,
        });
      },
      onSuccess: ({ data }) => {
        queryClient.invalidateQueries(queryKey);
        toast.success('Položka úspěšně vytvořena');
        getDetail(data.id);
        setOpenDialog(false);
      },
      onError: (err) => {
        console.error(err);
      },
    });

    const edit = useMutation({
      mutationFn: ({ id, values }: any) => {
        return apiService.patch(`/api/v1/${queryKey}/${id}/`, {
          ...(values as any),
        });
      },
      onSuccess: ({ data }: any, { id }: any) => {
        queryClient.invalidateQueries(queryKey);
        toast.success('Položka úspěšně editována');
        getDetail(id);
        setOpenDialog(false);

        if (name === 'phase') {
          dispatch({ type: UPDATE_CONTRACT, data: { modelId: data.model?.id } });
        }
      },
      onError: (err) => {
        console.error(err);
      },
    });

    const getDetail = (id) => {
      dispatch(fetchDetail(id));
    };

    useEffect(() => {
      queryClient.invalidateQueries(queryKey);
      dispatch(clear());
    }, [contractId]);

    const handleSubmit = (id, values) => {
      if (id) {
        (edit as any).mutate({ id, values });
        setIsEdit(false);
      } else {
        create.mutate(values);
      }
      setOpenDialog(false);
    };

    const handleEdit = () => {
      setIsEdit(true);
      setOpenDialog(true);
    };

    const handleCreated = (id) => {
      queryClient.invalidateQueries(queryKey);
      toast.success('Položka úspěšně vytvořena');
      getDetail(id);
      setOpenDialog(false);
    };

    const handleClose = () => {
      setIsEdit(false);
      setOpenDialog(false);
    };

    const onSearch = async (e) => {
      setSearch(e?.target?.value);
    };

    const onFilter = async (value) => {
      setFilter(value);
    };

    return (
      <SearchContext.Provider
        value={{
          search,
          filter,
          setSearch,
          setFilter,
        }}
      >
        <MainContainer>
          <NLeftPanel
            queryKey={queryKey}
            makeActive={getDetail}
            active={detail?.id}
            onSearch={onSearch}
            addItem={() => setOpenDialog(true)}
            onFilter={onFilter}
            defaultFilterValues={{ is_active: [true] }}
            title={t(name)}
            permission={permission}
            disableAdd={disableAdd}
            filteredValues={{
              is_active: [
                { value: true, title: 'Aktivni' },
                { value: false, title: 'Neaktivni' },
              ],
            }}
          />
          <Component
            openDialog={openDialog}
            isEdit={isEdit}
            handleSubmit={handleSubmit}
            handleCreated={handleCreated}
            handleEdit={handleEdit}
            handleClose={handleClose}
          />
        </MainContainer>
      </SearchContext.Provider>
    );
  };
};

export default withLeftPanelWrapper;
